<template>
  <div class="w-full flex flex-col max-w-768 mx-auto md:mt-20 py-24 md:py-48 px-16">
    <div>
      <p class="uppercase font-bold text-overline">Welcome to Sittercity</p>
      <h1 class="text-h1 mb-16">Let's continue your Back-Up Care request</h1>
    </div>
    <p class="mb-12">Which of these apply to you?</p>
    <div class="image-clickable-cards">
      <ImageLinkCard
        title="I already have a caregiver"
        content="Invite your existing caregiver to join Sittercity"
        class="mb-18 p-16"
        linkURL="/account/seekers/dashboard"
        :clickable="true"
      >
        <template #rightSide>
          <DisclosureIcon class="w-full" />
        </template>
        <template #leftSide>
          <SitterTeamIcon :width="48" :height="48" />
        </template>
      </ImageLinkCard>
      <ImageLinkCard
        title="I need a new caregiver"
        content="Find a new caregiver through Sittercity"
        class="mb-18 p-16"
        :linkURL="jobLink"
        :clickable="true"
      >
        <template #rightSide>
          <DisclosureIcon class="w-full" />
        </template>
        <template #leftSide>
          <FindCareIcon :width="48" :height="48" />
        </template>
      </ImageLinkCard>
    </div>
  </div>
</template>

<script lang="ts">
import ImageLinkCard from '@/components/image_link_card/ImageLinkCard.vue';
import DisclosureIcon from '@/graphics/icons/DisclosureIcon.vue';
import SitterTeamIcon from '../../../graphics/illustrations/SitterTeamIllustration.vue';
import FindCareIcon from '../../../graphics/illustrations/FindCareIllustration.vue';
import { CareType } from '@/types/care_type';

export default {
  name: 'BackupCareRequestSelection',
  components: {
    ImageLinkCard,
    DisclosureIcon,
    SitterTeamIcon,
    FindCareIcon,
  },
  props: {
    scCareSessions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    mostRecentlyCreatedActiveCareSession() {
      // get an iso string of the current date
      const currentDateISO = new Date().toISOString();
      // find the most recent created care session with a start date that has not expired
      const careSession: any = this.scCareSessions.reduce((mostRecent: any, session: any) => {
        const startDateExpired: boolean = session.start < currentDateISO;
        const isMoreRecentSession: boolean = session.createdAt > mostRecent?.createdAt || mostRecent === null;
        // check if the session is valid start time and more recent
        if (!startDateExpired && isMoreRecentSession) {
          return session;
        }
        return mostRecent;
      }, null);

      return careSession;
    },
    reservationIDQueryParam(): string {
      // get the reservation id from the most recent valid care session
      const mostRecentReservationId: string | null =
        this.mostRecentlyCreatedActiveCareSession?.bhReservationRequest?.bhReservationRequestId || null;

      if (mostRecentReservationId) {
        return `?reservationId=${mostRecentReservationId}`;
      }
      return '';
    },
    jobLink(): string {
      if (this.mostRecentlyCreatedActiveCareSession?.careType === CareType.COMPANION_CARE) {
        return '/job_posting/new?care_type=companion_care';
      }
      return `/job-post${this.reservationIDQueryParam}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.image-clickable-cards {
  .card-clickable {
    .w-64 {
      max-width: 3.5rem !important;
      width: 100%;
    }
  }
}
</style>
